import {ItemModel, ItemUnitModel, RowStateEnum, UserConfigurationModel, ValidationErrorModel} from "../../../models";
import {getLabelName} from "../../../utils";

export const validateSubmitRequest = (
    request: ItemModel,userConfiguration:UserConfigurationModel
): ValidationErrorModel[] => {
    let errors: ValidationErrorModel[] = [];
    // Validate basic details
    const basicValidationErrors = validateItemBasicDetail(request,userConfiguration);
    if (basicValidationErrors && basicValidationErrors.length > 0) {
        errors.push(...basicValidationErrors);
        return errors;
    }
    const validateAllowRepeatedFactoItemUnitErrors = validateAllowRepeatedFactoItemUnit(request,userConfiguration);
    if (validateAllowRepeatedFactoItemUnitErrors && validateAllowRepeatedFactoItemUnitErrors.length > 0) {
        errors.push(...validateAllowRepeatedFactoItemUnitErrors);
        return errors;
    }

    const validateAllowSellPriceLessThanCostPriceErrors = validateAllowSellPriceLessThanCostPrice(request,userConfiguration);
    if (validateAllowSellPriceLessThanCostPriceErrors && validateAllowSellPriceLessThanCostPriceErrors.length > 0) {
        errors.push(...validateAllowSellPriceLessThanCostPriceErrors);
        return errors;
    }

    return errors;
};

//#region private
const validateItemBasicDetail = (
    values: ItemModel,userConfiguration:UserConfigurationModel
): ValidationErrorModel[] => {
    let errorMessages: ValidationErrorModel[] = [];
    const itemUnits = values.ItemsInstores[0].Item_unit;
    if (values.Name === null || values.Name === undefined || values.Name === "") {
        errorMessages.push({
            MessageAr: getLabelName("nameAr.missing"),
            MessageEn: getLabelName("nameAr.missing"),
        });
    }
    if (!values.Cat_ID ) {
        errorMessages.push({
            MessageAr: getLabelName("categoryId.missing"),
            MessageEn: getLabelName("categoryId.missing"),
        });
    }

    if (itemUnits === null || itemUnits === undefined || itemUnits.length === 0) {
        errorMessages.push({
            MessageAr: getLabelName("no units added to item"),
            MessageEn: getLabelName("no units added to item"),
        });
    } else if (
        itemUnits[0].Unit_ID === null ||
        itemUnits[0].Unit_ID === undefined ||
        itemUnits[0].Unit_ID === 0
    ) {
        errorMessages.push({
            MessageAr: getLabelName("no units added to item"),
            MessageEn: getLabelName("no units added to item"),
        });
    }

    if (
        errorMessages === null ||
        errorMessages === undefined ||
        errorMessages.length === 0
    ) {
        const activeUnitsCount = itemUnits.filter(
            (p: ItemUnitModel) => p.rowState !== Number(RowStateEnum.Delete)
        ).length;
        const smallestActiveUnitCount = itemUnits.filter(
            (p: ItemUnitModel) => p.rowState !== 3 && p.IsSmallestUnit
        ).length;
        if (activeUnitsCount === 0) {
            errorMessages = errorMessages ?? [];
            errorMessages.push({
                MessageAr: getLabelName("no units added to item"),
                MessageEn: getLabelName("no units added to item"),
            });
        }

        if (activeUnitsCount > 1 && smallestActiveUnitCount === 0) {
            errorMessages = errorMessages ?? [];
            errorMessages.push({
                MessageAr: getLabelName("no smallest unit selected"),
                MessageEn: getLabelName("no smallest unit selected"),
            });
        }
        if (smallestActiveUnitCount > 1) {
            errorMessages = errorMessages ?? [];
            errorMessages.push({
                MessageAr: getLabelName("only one  smalls unit allowed"),
                MessageEn: getLabelName("only one  smalls unit allowed"),
            });
        }
    }
    return errorMessages;
};
const validateAllowRepeatedFactoItemUnit= (
    request: ItemModel,userConfiguration:UserConfigurationModel
): ValidationErrorModel[] =>{
    let errors: ValidationErrorModel[] = [];
    if(!userConfiguration.userSetting.AlowRepeateFactoItemUnit){
        const storesWithDuplicates = request.ItemsInstores.filter(store => {
            if (!store.Item_unit) return false; // Ensure Item_unit exists
            const unitIds = store.Item_unit.map(unit => unit.Unit_ID);
            return new Set(unitIds).size !== unitIds.length;
        });

        if (storesWithDuplicates.length > 0) {
            errors.push({
                MessageAr: getLabelName("duplicate unit IDs found"),
                MessageEn: getLabelName("duplicate unit IDs found"),
            });
        }
    }

    return  errors;
}
const validateAllowSellPriceLessThanCostPrice = (
    request: ItemModel,userConfiguration:UserConfigurationModel
): ValidationErrorModel[] => {
    let errors: ValidationErrorModel[] = [];
    const isOpenItem = Boolean(request.OpenItem);
    if (!isOpenItem && !userConfiguration.userSetting.AllowItemPriceSaleLessThanCost) {
        const invalidPriceUnits = request.ItemsInstores.filter(store => {
            if (!store.Item_unit) return false; // Ensure Item_unit exists
            return store.Item_unit.some(unit => Number(unit.PriceSale) < Number(unit.PriceQutyBegBal));
        });
        if (invalidPriceUnits.length > 0) {
            errors.push({
                MessageAr: getLabelName("Price Sale should not be less than Price Quty Begin Balance"),
                MessageEn: getLabelName("Price Sale should not be less than Price Quty Begin Balance"),
            });
        }
    }
    return errors
}
//#endregion